import { useState } from "react";

const PaymentPageHeaderService = () => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      sessionStorage.removeItem("sessionID");
      sessionStorage.removeItem("session");
      sessionStorage.removeItem("userID");
      window.location.href = "/";
    }
  };
  return { toggleDropdown, showDropdown, handleLogout };
};

export default PaymentPageHeaderService;
